
import VueMasonry from 'vue-masonry-css'

export default ({ Vue }) => {
  Vue.use(VueMasonry)
}
